import { render } from "./HowItWorks.vue?vue&type=template&id=336b068b&scoped=true"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"

import "./HowItWorks.vue?vue&type=style&index=0&id=336b068b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336b068b"]])

export default __exports__